import React, { useState } from "react";
import { useSelector } from "react-redux";
import AsKop from "./KombansiMoSubComponents/AsKop";
import KepalaEkor from "./KombansiMoSubComponents/KepalaEkor";
import AsKopKepalaEkor from "./KombansiMoSubComponents/AsKopKepalaEkor";
const KombinasiMo = () => {
  const app_type = useSelector(state => state.CommonConfig.app_type);
  const device = useSelector(state => state.CommonConfig.device_type);
  const [activeTab, setActiveTab] = useState(1);
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  return (
    <>
      <div className="main_page tengah_dasar kombinasi_mo">
        <div className="main_nav-tabwrapper">

          <div
            className={`main_tab ${activeTab === 1 ? "active" : ""}`}
            onClick={() => handleTabClick(1)}
          >
            AS dan KOP
          </div>
          <div
            className={`main_tab ${activeTab === 2 ? "active" : ""}`}
            onClick={() => handleTabClick(2)}
          >
            KEPALA dan EKOR
          </div>
          <div
            className={`main_tab ${activeTab === 3 ? "active" : ""}`}
            onClick={() => handleTabClick(3)}
          >
            AS/KOP dan KEPALA EKOR
          </div>
        </div>
        <div className="maintabcontent-wrapper">

          {activeTab === 1 && (

            <AsKop />

          )}
          {activeTab === 2 && (

            <KepalaEkor />

          )}
          {activeTab === 3 && (

            <AsKopKepalaEkor />

          )}
        </div>
      </div>
    </>
  );
};
export default KombinasiMo;